/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconClose from '@telus-uds/palette-public-mobile/build/rn/icons/Close'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        footnoteBodyPaddingBottom: 32,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 16,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 16
      }
    },
    {
      if: { viewport: [ 'md', 'lg' ] },
      tokens: {
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 4,
        footnoteHeaderPaddingTop: 24
      }
    },
    {
      if: { viewport: [ 'xl' ] },
      tokens: {
        footnoteBodyPaddingBottom: 40,
        footnoteBodyPaddingLeft: 16,
        footnoteBodyPaddingRight: 16,
        footnoteBodyPaddingTop: 0,
        footnoteHeaderPaddingBottom: 24,
        footnoteHeaderPaddingLeft: 16,
        footnoteHeaderPaddingRight: 16,
        footnoteHeaderPaddingTop: 24
      }
    }
  ],
  tokens: {
    closeButtonBackgroundColor: '#ffffff',
    closeButtonBorderColor: '#394056',
    closeButtonBorderSize: 1,
    closeButtonHeight: 24,
    closeButtonIconSize: 16,
    closeButtonMarginBottom: 4,
    closeButtonMarginLeft: 4,
    closeButtonMarginRight: 12,
    closeButtonMarginTop: 12,
    closeButtonWidth: 24,
    closeIcon: PaletteIconClose,
    footnoteBackground: '#ffffff',
    footnoteBodyBackground: '#ffffff',
    footnoteBodyPaddingBottom: 40,
    footnoteBodyPaddingLeft: 16,
    footnoteBodyPaddingRight: 16,
    footnoteBodyPaddingTop: 0,
    footnoteBorderColorMd: '#cdcfd5',
    footnoteBorderTopSizeMd: 1,
    footnoteHeaderPaddingBottom: 24,
    footnoteHeaderPaddingLeft: 16,
    footnoteHeaderPaddingRight: 4,
    footnoteHeaderPaddingTop: 24,
    headerFontName: 'SofiaPro',
    headerFontSize: 16,
    headerFontWeight: '700',
    headerLineHeight: 1.5,
    headerMargin: 16,
    listItemColor: '#394056',
    listItemFontName: 'SofiaPro',
    listItemFontSize: 16,
    listItemFontWeight: '400',
    listItemLineHeight: 1.5,
    listItemMarkerFontSize: 16,
    listItemMarkerLineHeight: 1.5,
    listItemPaddingLeft: 8,
    listPaddingLeft: 32
  }
}
export default theme
